import { render, staticRenderFns } from "./AccountMemberCardModalHeader.vue?vue&type=template&id=fda1f5d6&scoped=true&"
import script from "./AccountMemberCardModalHeader.vue?vue&type=script&lang=js&"
export * from "./AccountMemberCardModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccountMemberCardModalHeader.vue?vue&type=style&index=0&id=fda1f5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda1f5d6",
  null
  
)

export default component.exports